type UserOrderIdType = {
  userId: string
  orderId: string
}

const recipeCards = ({ userId, orderId }: UserOrderIdType) =>
  `/get-help/user/${userId}/order/${orderId}/recipe-cards`

export const address = {
  postcodeLookup: '/address/postcode-lookup',
}

export const auth = {
  userToken: '/oauth/access-token',
  clientToken: '/oauth/access-token',
  refreshToken: '/oauth/refresh-token',
  identifyUser: '/oauth/identify',
  validateUserPassword: '/passwords/validate',
  resetUserPassword: '/passwords',
  login: '/login',
  logout: '/logout',
  refresh: '/refresh',
  identify: '/identify',
  forget: '/forget',
  validate: '/validate',
}

export const client = {
  appsRedirect: '/apps',
  blog: '/blog',
  boxPrices: '/box-prices',
  carbonFootprintComparison: 'https://cook.gousto.co.uk/carbon-footprint-comparison/',
  checkout: '/checkout',
  'check-out': '/check-out',
  cookbook: '/cookbook',
  cookbookRecipeById: '/cookbook/recipe-by-id',
  cookbookAllRecipes: '/cookbook/recipes',
  mySubscription: '/subscription-settings',
  deprecated__mySubscription: '/my-subscription',
  myDetails2: '/mydetails',
  myReferral2: '/myreferrals',
  rateRecipes2: '/rate-recipes',
  getHelp: {
    confirmation: 'confirmation',
    contact: 'contact',
    delivery: ({ userId, orderId }: UserOrderIdType) =>
      `/get-help/user/${userId}/order/${orderId}/delivery`,
    index: '/get-help',
    ingredientIssues: 'ingredient-issues',
    ingredientReasons: 'ingredient-reasons',
    multipleIngredientsIssues: 'multiple-ingredients-issues',
    ingredients: ({ userId, orderId }: UserOrderIdType) =>
      `/get-help/user/${userId}/order/${orderId}/ingredients`,
    orderIssue: 'order-issue',
    recipeCards,
    recipeCardsConfirmation: ({ userId, orderId }: UserOrderIdType) =>
      `${recipeCards({ userId, orderId })}/confirmation`,
    recipeCardsSelect: ({ userId, orderId }: UserOrderIdType) =>
      `${recipeCards({ userId, orderId })}/select`,
    recipeCardsIssues: ({ userId, orderId }: UserOrderIdType) =>
      `${recipeCards({ userId, orderId })}/issues`,
    refund: 'refund',
    sameDayIngredientIssues: 'same-day-ingredient-issues',
  },
  help: '/help',
  helpCentre: '/help-centre',
  home: '/',
  home2: '/home',
  jobs: '/jobs',
  join: '/join',
  join2: '/join2',
  login: '/login',
  logout: '/logout',
  menu: '/menu',
  deliveryDetails: '/delivery-details',
  myDetails: '/account-details',
  myGousto: '/my-gousto',
  myDeliveries: '/my-deliveries',
  deprecated__myDetails: '/my-details',
  myReferral: '/my-referrals',
  rateMyRecipes: '/rate-my-recipes',
  nwr: '/menu',
  raf: '/raf',
  payment: {
    success: '/payment/success',
    failure: '/payment/failure',
  },
  privacyCookiesPolicies: '/privacy-and-cookies-policies',
  privacyPolicy: '/privacy-policy',
  modernSlavery: '/modern-slavery-statement',
  accessibilityStatement: '/accessibility-statement',
  studentDiscount: 'https://cook.gousto.co.uk/studentdiscount/',
  resetForm: '/resetform',
  welcome: '/welcome-to-gousto',
  orderConfirmation: '/order-confirmation/:orderId',
  termsAndConditions: '/terms-and-conditions',
  termsOfUse: '/terms-of-use',
  twr: '/menu',
  weCare: '/blog/sustainability',
  referFriend: '/my-referrals',
  signup: '/signup',
  resetPassword: '/newpasswordform',
  unsubscribe: '/unsubscribe',
  ourSuppliers: 'https://www.gousto.co.uk/blog/suppliers',
  verificationOfChoice: 'https://cook.gousto.co.uk/choice/',
  howGoustoWorks: '/food-box/how-it-works',
  goustoMealPlanning: '/food-box/gousto-menu-and-plans',
  foodBox: '/food-box',
}

export const core = {
  boxPrices: '/boxPrices',
  holdReason: '/info/holdreason',
  prices: '/prices',
  orderPreview: '/order/preview',
  order: '/order',
  productStock: '/products/stock',
  recipesStock: '/stock/recipe',
  userOrders: '/user/current/orders',
  userOrder: '/user/current/order',
  userAddress: '/user/current/address',
  userPromo: '/user/current/promotion-codes',
  currentUser: '/user/current',
  user: '/user',
  cancelPending: '/user/current/cancel-pending-orders',
  applyPromo: '/user/current/applyPromotionCode',
  reference: '/user/reference',
}

export const craftyclicks = {
  endpoint: 'http://pcls1.craftyclicks.co.uk/json/rapidaddress',
}

export const customers = {
  pauseReasons: '/subscription/pause-reasons',
  signup: '/signup',
  promocode: '/customers/promocode',
}

export const deliveries = {
  days: '/days',
  consignments: '/consignments',
}

export const logs = {
  event: '/event',
}

export const menu = {
  menus: '/menus',
}

export const orders = {
  recipesStock: '/stock/recipes',
}

export const products = {
  getProducts: '/products',
  categories: '/categories',
}

export const ssr = {
  validateIngredients: '/validate-ingredients',
}

export const ssrrecipecards = {
  validate: '/validate',
}

export const subscriptionCommand = {
  skip: '/skip',
  unSkip: '/unskip',
  deactivate: '/deactivate',
  activate: '/activate',
}

export const subscriptionQuery = {
  subscriptions: '/subscriptions',
  projectedDeliveries: '/projected-deliveries',
  subscriptionOptions: '/subscription-options',
}

export const zendesk = {
  covid:
    'https://gousto.zendesk.com/hc/en-gb/articles/360006713417--How-does-the-coronavirus-situation-affect-Gousto-',
  emailForm: 'https://gousto.zendesk.com/hc/en-gb/requests/new',
}

export const recaptcha = {
  verify: 'https://www.google.com/recaptcha/api/siteverify',
}

export const unbounce = {
  covid: 'https://cook.gousto.co.uk/coronavirus-3/',
}

export const userFeedback = {
  feedback: '/feedback',
}

// eslint-disable-next-line import/no-default-export
export default {
  address,
  auth,
  client,
  core,
  craftyclicks,
  customers,
  deliveries,
  logs,
  menu,
  orders,
  products,
  ssr,
  ssrrecipecards,
  subscriptionCommand,
  subscriptionQuery,
  zendesk,
  recaptcha,
  unbounce,
  userFeedback,
}
